import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OldOnboarding } from '../constants/onboardingVersions';

const useOnboardingNavigation = (currentPageNumber, numberOfPages, routePrefix = `${OldOnboarding}`) => {
  const navigate = useNavigate();

  const setPage = useCallback((page) => {
    navigate(`/${routePrefix}/${page}`);
  }, [navigate, routePrefix]);

  const nextPage = useCallback(() => {
    if (currentPageNumber < numberOfPages) {
      setPage(currentPageNumber + 1);
    }
  }, [currentPageNumber, numberOfPages, setPage]);

  const prevPage = useCallback(() => {
    if (currentPageNumber > 1) {
      const stepBack = currentPageNumber === numberOfPages ? 2 : 1;
      setPage(currentPageNumber - stepBack);
    }
  }, [currentPageNumber, numberOfPages, setPage]);

  return { setPage, nextPage, prevPage };
};

export default useOnboardingNavigation;
